import React, { useEffect, useRef, useState } from "react";
import Layout from "../Common/Layout";
import axios from "axios";
import { useParams } from "react-router-dom";

const CDDPrint = () => {
  const { cddNo } = useParams();
  const token = sessionStorage.getItem("token");

  const formRef = useRef();

  const [formdata, setFormData] = useState({});
  const [trucks, setTrucks] = useState([]);

  // ======================
  // FETCH CDD
  // ======================
  const fetchCDD = async () => {
    try {
      const res = await axios.get(
        `https://irc.zentelex.com/api/cdd-receipts/cdd-print/${cddNo}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = res.data.data;
      if (!data) return;

      setFormData({
        cddNo: data.cddNo,
        Date: data.documentDate,
        WarehouseName: data.warehouseName,
        WarehouseAddress: data.warehouseAddress,
        LocationName: data.locationName || "-",
        ClientName: data.clientName,
        ClientAddress: data.clientAddress,
        NameofReceipent: data.recipientName || "-",
        ReceipentProof: data.proofType || "-",
        IdNo: data.recipientIdNo || "-",
        CommodityName: data.commodityName,
        Variety: data.variety,
        DoNo: data.doNo,
        DoDate: data.doDate,
        NoOfPack: data.noOfPack,
        Weight: data.weightMt,
        Chamber: data.chamber || "-",
        GatePassNo: data.gatePassNo,
        WeighBridgeName: data.weighBridgeName,
        ClientSignatory: data.clientSignatoryName || "-",
        Remarks: data.remarks || "-",
      });

      setTrucks(data.truckDetails || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCDD();
  }, []);

  // ======================
  // PRINT
  // ======================
  const handlePrint = () => {
    const printContents = formRef.current.innerHTML;
    const win = window.open("", "_blank");

    win.document.write(`
      <html>
      <head>
        <title>CDD Print</title>
        <style>
          body{ font-family: Arial; padding:20px; }
          h2,h3,h4{ text-align:center; margin:4px; }
          table{ width:100%; border-collapse:collapse; margin-top:10px; }
          td,th{ border:1px solid black; padding:6px; font-size:14px; }
          .section-title{ font-weight:bold; margin-top:15px; font-size:18px; }
          .box{ padding:4px; }
          @media print { button{ display:none; } }
        </style>
      </head>
      <body>${printContents}</body>
      </html>
    `);

    win.document.close();
    win.print();
  };

  return (
    <Layout>
      <div className="container mt-4">

        {/* ===== RESPONSIVE STYLES ===== */}
        <style>{`
          .cdd-paper{
            background:#fff;
            padding:20px;
            border-radius:6px;
          }

          .center{
            text-align:center;
          }

          .doc-title{
            text-align:center;
            font-weight:bold;
            margin-top:10px;
          }

          table{
            width:100%;
            border-collapse:collapse;
            margin-top:10px;
          }

          th,td{
            border:1px solid #000;
            padding:6px;
            font-size:14px;
          }

          .box{
            word-break:break-word;
          }

          .table-responsive{
            width:100%;
            overflow-x:auto;
          }

          /* MOBILE FIX */
          @media (max-width:768px){

            .container{
              padding-left:8px;
              padding-right:8px;
            }

            .cdd-paper{
              padding:12px;
            }

            th,td{
              font-size:12px;
              padding:5px;
            }

            h2{ font-size:18px; }
            h3{ font-size:16px; }
            h4{ font-size:14px; }

            table{
              min-width:600px;
            }
          }
        `}</style>

        <div ref={formRef} className="cdd-paper">

          {/* HEADER */}
          <h2>IRC LIMITED</h2>

          <p className="center">
            IRC HOUSE, 1 SUNYAT SEN STREET , KOLKATA-700012 <br/>
            TELEPHONE NO.: +91-33-2236-5110 (5 Lines) FAX: +91-33-2225 5936 <br/>
            Email: ho@ircl.in
          </p>

          <h3 className="doc-title">COMMODITY DELIVERY DOCUMENT</h3>

          {/* CDD DETAILS */}
          <div className="table-responsive">
            <table>
              <tbody>
                <tr>
                  <th>CDD No.</th>
                  <td>{formdata.cddNo}</td>
                  <th>Date</th>
                  <td>{formdata.Date}</td>
                </tr>
                <tr>
                  <th>Location</th>
                  <td>{formdata.LocationName}</td>
                  <th>DO No.</th>
                  <td>{formdata.DoNo}</td>
                </tr>
                <tr>
                  <th>DO Date</th>
                  <td>{formdata.DoDate}</td>
                  <th>Gate Pass No.</th>
                  <td>{formdata.GatePassNo}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* WAREHOUSE */}
          <h4 className="section-title">Warehouse Details</h4>

          <div className="table-responsive">
            <table>
              <tbody>
                <tr>
                  <th>Warehouse Name</th>
                  <td>{formdata.WarehouseName}</td>
                  <th>Warehouse Address</th>
                  <td>{formdata.WarehouseAddress}</td>
                </tr>
                <tr>
                  <th>Chamber</th>
                  <td>{formdata.Chamber}</td>
                  <th>Weigh Bridge</th>
                  <td>{formdata.WeighBridgeName}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* CLIENT */}
          <h4 className="section-title">Client Details</h4>

          <div className="table-responsive">
            <table>
              <tbody>
                <tr>
                  <th>Client Name</th>
                  <td>{formdata.ClientName}</td>
                  <th>Client Address</th>
                  <td>{formdata.ClientAddress}</td>
                </tr>
                <tr>
                  <th>Name of Recipient</th>
                  <td>{formdata.NameofReceipent}</td>
                  <th>Proof Type</th>
                  <td>{formdata.ReceipentProof}</td>
                </tr>
                <tr>
                  <th>ID No.</th>
                  <td>{formdata.IdNo}</td>
                  <th>Client Signatory</th>
                  <td>{formdata.ClientSignatory}</td>
                </tr>
                <tr>
                  <th>Commodity Name</th>
                  <td>{formdata.CommodityName}</td>
                  <th>Variety</th>
                  <td>{formdata.Variety}</td>
                </tr>
                <tr>
                  <th>No of Packs</th>
                  <td>{formdata.NoOfPack}</td>
                  <th>Weight (MT)</th>
                  <td>{formdata.Weight}</td>
                </tr>
                <tr>
                  <th>Remarks</th>
                  <td colSpan="3">{formdata.Remarks}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* TRUCK DETAILS */}
          <h4 className="section-title">Truck Details</h4>

          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Truck No</th>
                  <th>Weight / Truck</th>
                  <th>No of Bags</th>
                </tr>
              </thead>
              <tbody>
                {trucks.map((t, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{t.truckNo}</td>
                    <td>{t.weightPerTruck}</td>
                    <td>{t.noOfBags}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>

        {/* PRINT BUTTON */}
        <div className="text-center mt-4">
          <button className="btn btn-primary" onClick={handlePrint}>
            Print CDD Form
          </button>
        </div>

      </div>
    </Layout>
  );
};

export default CDDPrint;